import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-school-parent-requests',

  templateUrl: './school-parent-requests.component.html',

  styleUrls: ['./school-parent-requests.component.css']

})

export class SchoolParentRequestsComponent implements OnInit {

  lst_RequestType = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strNationalCode: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),


  })

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iPassenger: new FormControl('', Validators.required),

    tiMadonik_RequestType: new FormControl('', Validators.required),

    strDetail: new FormControl('', Validators.required),

    strMobileDomain_strComment: new FormControl('', Validators.required),

    strPassenger_FullName: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    strCityName: new FormControl('', Validators.required),

    strSchoolType_strComment: new FormControl('', Validators.required),

    strSex_strSexComment: new FormControl('', Validators.required),

    strEducationLevel_strComment: new FormControl('', Validators.required),

    strGrade: new FormControl('', Validators.required),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getRequestType();

  }

  async getRequestType() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_RequestType_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'xq111vdf0' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_RequestType = res;
  }

  async getStudent() {

    if (this.mdl_Search.get('strNationalCode')?.hasError('required')) {

      return this._tooltip.showError('کد ملی را وارد کنید!');

    }

    if (this.mdl_Search.get('strNationalCode')?.hasError('minlength') || this.mdl_Search.get('strNationalCode')?.hasError('maxlength')) {

      return this._tooltip.showError('کد ملی باید 10 رقم باشد!!');

    }

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_Request_SearchStudentByID`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'xq111zad0' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    if(!res.length) return this._tooltip.showError('دانش آموزی با این کد ملی پیدا نشد.')

    Object.keys(res[0]).forEach(key => {

      this.mdl_Request.get(key)?.setValue(res[0][key])

    })

    this.mdl_Request.patchValue({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      tiMadonik_RequestType: '',

      strDetail: '',

    })

  }

  async submitRequest() {

    if (this.mdl_Request.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید');

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_Request_Save`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'xq11s10' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess(`درخواست با کد ${res[0].iMadonik_Request} با موفقیت ثبت شد.`);

    this.mdl_Request.patchValue({

      iPassenger: '',

      tiMadonik_RequestType: '',

      strDetail: '',

      strMobileDomain_strComment: '',

      strPassenger_FullName: '',

      strMobile: '',

      strCityName: '',

      strSchoolType_strComment: '',

      strSex_strSexComment: '',

      strEducationLevel_strComment: '',

      strGrade: '',

    })

    this.mdl_Search.patchValue({

      strNationalCode: ''

    })


  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  submitValue2(event) {

    if (event?.iSystemUser) {

      this.mdl_Request.patchValue({

        tiMadonik_RequestType: event.tiMadonik_RequestType,

      })

    }

    else {

      this.mdl_Request.patchValue({

        tiMadonik_RequestType: '',


      })


    }


  }

}
